var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import I18n from '@utils/i18n';
import { proposedCorrectionsPath, destroyUserSessionPath } from '@routes';
import { Text, Button, InlineNotification } from '@ui';
import QbImportedBanner from './QbImportedBanner';
import QbRetiredBanner from './QbRetiredBanner';
import QbLinkDetails from './QbLinkDetails';
import ProposedCorrectionForm from './ProposedCorrectionForm';
import PriceLevelsTable from './PriceLevelsTable';
import { useProposedCorrectionSubmit } from './useProposedCorrectionSubmit';
import './EditProposedCorrectionStyles.scss';
import { SaveFailure } from './types';
function EditProposedCorrection({ categoriesForSelect, materialTypesForSelect, serviceTypesForSelect, qbdClassesForSelect, qbdEnabled, enablePriceList, editLocked, qboRetiredOn = null, qbLink = null, proposedCorrection: initialData }) {
    var _a, _b;
    const [formData, setFormData] = useState({
        category: initialData.category || 'material',
        description: initialData.description || '',
        description_other: initialData.description_other || '',
        proposed_correction_type_id: initialData.proposed_correction_type_id || '',
        manufacturer: initialData.manufacturer || '',
        model_number: initialData.model_number || '',
        part_number: initialData.part_number || '',
        list_price: initialData.list_price,
        unit_cost: initialData.unit_cost,
        price: initialData.price,
        active: (_a = initialData.active) !== null && _a !== void 0 ? _a : true,
        taxable: (_b = initialData.taxable) !== null && _b !== void 0 ? _b : false,
        qb_class_ref_id: initialData.qb_class_ref_id || ''
    });
    const [priceLevels, setPriceLevels] = useState((initialData.price_levels || []).map((pl) => (Object.assign({}, pl))));
    const { submitting, errors, saveFailure, submit } = useProposedCorrectionSubmit(initialData.id);
    const showPriceLevels = !enablePriceList || priceLevels.length > 0;
    const handleAddPriceLevel = () => {
        setPriceLevels([...priceLevels, { id: null, name: '', price: '', active: true }]);
    };
    const handleRemovePriceLevel = (index) => {
        setPriceLevels(priceLevels.filter((_, i) => i !== index));
    };
    const handleSubmit = (e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        if (editLocked)
            return;
        yield submit({ formData, priceLevels });
    });
    return (React.createElement("form", { className: "pc-edit", id: "proposed-corrections-form", onSubmit: handleSubmit },
        React.createElement("div", { className: "mb-2" },
            React.createElement("a", { href: proposedCorrectionsPath(), className: "btn btn-link pc-edit__back-link" },
                React.createElement("i", { className: "fa-light fa-arrow-left" }),
                " ",
                React.createElement(Text, { variant: "link" }, I18n.t('generic.back')))),
        errors && (React.createElement("div", { className: "alert alert-error" },
            React.createElement("ul", null, Object.entries(errors).map(([field, messages]) => (React.createElement("li", { key: field },
                React.createElement(Text, { variant: "body" },
                    field !== 'base' && `${field} `,
                    Array.isArray(messages) ? messages.join(', ') : messages))))))),
        React.createElement("div", { className: "page-content" },
            React.createElement(Text, { variant: "small", as: "h4", className: "pc-edit__heading" }, I18n.t('settings.proposed_corrections.form.main_header.edit')),
            qbLink && React.createElement(QbLinkDetails, { qbLink: qbLink }),
            !initialData.active && qboRetiredOn && React.createElement(QbRetiredBanner, { retiredOn: qboRetiredOn }),
            editLocked && React.createElement(QbImportedBanner, null),
            React.createElement(ProposedCorrectionForm, { formData: formData, onChange: setFormData, disabled: editLocked, categoriesForSelect: categoriesForSelect, materialTypesForSelect: materialTypesForSelect, serviceTypesForSelect: serviceTypesForSelect, qbdClassesForSelect: qbdClassesForSelect, qbdEnabled: qbdEnabled }),
            showPriceLevels && (React.createElement(PriceLevelsTable, { priceLevels: priceLevels, onChange: setPriceLevels, onAdd: handleAddPriceLevel, onRemove: handleRemovePriceLevel, disabled: editLocked, enablePriceList: enablePriceList }))),
        !editLocked && saveFailure === SaveFailure.SESSION_EXPIRED && (React.createElement(InlineNotification, { variant: "error", title: I18n.t('proposed_corrections.update.not_saved_title'), action: React.createElement("a", { className: "qmb-ui-button qmb-ui-button--secondary", href: destroyUserSessionPath(), "data-method": "delete", rel: "nofollow" }, I18n.t('proposed_corrections.update.sign_in')) }, I18n.t('proposed_corrections.update.session_expired_message'))),
        !editLocked && saveFailure === SaveFailure.UNEXPECTED && (React.createElement(InlineNotification, { variant: "error", title: I18n.t('proposed_corrections.update.not_saved_title') }, I18n.t('proposed_corrections.update.unexpected_error_message'))),
        !editLocked && (React.createElement("div", { className: "form-actions pc-edit__footer" },
            React.createElement(Button, { variant: "primary", type: "submit", disabled: submitting, className: "pc-edit__submit-btn" }, submitting ? I18n.t('generic.saving') : I18n.t('generic.update'))))));
}
export default EditProposedCorrection;
